import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { MD5 } from "crypto-js";
import { Icon } from "@iconify/react";
import { TextField } from "@mui/material";
import "./Login.css";
// import LogoClient from "../Images/LogoClient.png";
import RevokeAccessDialog from "./RevokeAccessDialog";
import LogoMoxcal from "../Images/LogoMoxcalHighRes.png";

import {
  accessMenu,
  agentPermission,
  systemParameter,
  userLogin,
} from "../Store/Actions/AuthAction";

import { getAccount } from "../Store/Actions/WABAAction";

import {
  ERROR_CLEARALL,
  SET_ACCESS_MENU,
  SET_AGENT_PERMISSION,
  SET_INBOUND_SAVE_TICKET,
} from "../Store/Types/AuthTypes";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [state, setState] = useState({
    username: "",
    password: "",
  });
  const [validName, setValidName] = useState(false);
  const [validPwd, setValidPwd] = useState(false);
  const [disable, setDisable] = useState(false);
  const [isRevokeAvailable, setIsRevokeAvailable] = useState(false);

  const [isRevokeAccessDialogShown, setIsRevokeAccessDialogShown] =
    useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  // Check existing session
  const [exists, setExists] = useState(false);

  useEffect(() => {
    const item = localStorage.getItem("token");

    if (item) {
      setExists(true);
    } else {
      setExists(false);
    }
  }, []);

  const inputHandle = (e) => {
    setState({
      ...state,
      [e.target.id]: e.target.value,
    });

    setErrorMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    localStorage.removeItem("isNotFirstLoad");
    localStorage.removeItem("bypassAntiRefresh");
    const hash = MD5(state.password).toString();

    setDisable(true);
    setTimeout(() => {
      setDisable(false);
    }, 2000);

    dispatch(userLogin(state.username, hash));
  };

  const { authenticate, errorMessageAuth, successMessageAuth, myInfo } =
    useSelector((state) => state.auth);

  useEffect(() => {
    const USER_REGEX = /^[a-zA-Z][a-zA-Z0-9-_]{4,23}$/;
    const result = USER_REGEX.test(state.username);
    setValidName(result);
  }, [state.username]);

  useEffect(() => {
    const PWD_REGEX = /^[A-Za-z0-9_.!]{4,24}$/;
    const result = PWD_REGEX.test(state.password);
    setValidPwd(result);
  }, [state.password]);

  useEffect(() => {
    if (authenticate) {
      accessMenu(myInfo.user.FKGroupMenuID)
        .then((response) => {
          if (response.status) {
            console.log("access menu: ", response.data);
            dispatch({ type: SET_ACCESS_MENU, payload: response.data });
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });

      agentPermission()
        .then((response) => {
          if (response.status) {
            process.env.NODE_ENV === "development" &&
              console.log("agent permission: ", response.data);

            dispatch({ type: SET_AGENT_PERMISSION, payload: response.data });
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });

      // Get system parameter setting for inbound ticket
      systemParameter(35)
        .then((response) => {
          if (response.status) {
            console.log("inbound save ticket: ", response.data);
            dispatch({ type: SET_INBOUND_SAVE_TICKET, payload: response.data });
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });

      // Get WABA Account
      getAccount()
        .then((response) => {
          if (response.status) {
            console.log("WABA Account", response);

            localStorage.setItem(
              "WABAAccessToken",
              response.data[0].AccessToken
            );
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });

      navigate("/");
      setIsRevokeAvailable(false);
    }

    if (errorMessageAuth) {
      if (
        errorMessageAuth.includes("User Not Found!") ||
        errorMessageAuth.includes("Invalid Password!")
      ) {
        setErrorMessage("Username or Password is invalid. Please check again.");
      } else {
        if (errorMessageAuth.includes("already exist")) {
          setIsRevokeAvailable(true);
        }

        toast.warn(errorMessageAuth);
      }

      dispatch({ type: ERROR_CLEARALL });
    }
  }, [successMessageAuth, errorMessageAuth]);

  // Clear token & current page
  // useEffect(() => {
  //   localStorage.removeItem("token");
  //   localStorage.removeItem("winPage");
  // }, []);

  const handleOnLoad = () => {
    // console.log("trigger", process.env.NODE_ENV);

    if (exists) {
      // Temp hidden
      // toast.info("Previous Session Exist!", {
      //   autoClose: 3000,
      // });

      localStorage.clear();
    }
  };

  return (
    <div className="LoginMain">
      {handleOnLoad()}

      <div className="LoginBody">
        {/* remove logo by request */}
        {/* <div className="LoginLogoContainer">
          <img src={LogoMoxcal} className="LoginLogo" alt="" />
        </div> */}
        {/* ini gambarnya */}

        {/* <img src={BackgroundVector} className="BackgroundImage"></img> */}

        <div className="LoginBodyContainer">
          <img src={LogoMoxcal} alt="" className="clientLogo" />
          <form onSubmit={handleSubmit}>
            <div className="LoginBodyText">
              <div className="headerSignIn">Sign in to your account.</div>
              <div className="headerRegular">
                Login to Centerix Omnichannel App
              </div>
            </div>
            <div className="LabelContainer">
              <p className={`error-message ${errorMessage ? "visible" : ""}`}>
                {errorMessage}
              </p>

              <TextField
                autoComplete="off"
                error={
                  errorMessage ? true : state.username ? !validName : false
                }
                id="username"
                label="Username"
                name="username"
                required
                onChange={inputHandle}
              />

              <TextField
                autoComplete="off"
                error={errorMessage ? true : state.password ? !validPwd : false}
                id="password"
                label="Password"
                name="password"
                required
                type="password"
                value={state.password}
                onChange={inputHandle}
              />
            </div>

            <button className="btnSubmit" type="submit" disabled={disable}>
              {!disable && <Icon icon="mdi:login-variant" height="30" />}

              {disable && (
                <i
                  className="fa fa-circle-o-notch fa-spin"
                  style={{ marginRight: "5px" }}
                />
              )}

              {disable && <span>Loading...</span>}
              {!disable && <span>Login</span>}
            </button>

            {isRevokeAvailable && (
              <button
                className="btnSubmit revoke"
                type="button"
                onClick={() => setIsRevokeAccessDialogShown(true)}
              >
                <Icon icon="mdi:lock-open-alert-outline" height="30" />
                <span>Revoke Access</span>
              </button>
            )}
          </form>
        </div>
        <div className="BackgroundContainer" />
      </div>

      <RevokeAccessDialog
        isOpen={isRevokeAccessDialogShown}
        setIsRevokeAccessDialogShown={setIsRevokeAccessDialogShown}
      />
    </div>
  );
}
